import React, { useState, useEffect, useRef } from "react";
import styles from "../../App.module.css";

import {
  FaCheck, FaTimes, FaWhatsapp, FaWpforms, FaExternalLinkAlt, FaCheckCircle, FaHourglassHalf, FaRegFileAlt, FaPencilAlt,
} from "react-icons/fa";
import api from "../../api/axios";
import { format, parseISO } from "date-fns";
import ModalFinalizar from "../../components/ModalFinalizar";
import ListaFormularios from "../../components/ListaFormularios";


const Pendencias = ({ user, userPermission, userCpf }) => {
  const [usersList, setUsersList] = useState([]);
  const [allUsersList, setAllUsersList] = useState([]);
  const [usersProdList, setUsersProdList] = useState([]);
  const [allUsersProdList, setAllUsersProdList] = useState([]);
  const [pendenciaOn, setPendenciaOn] = useState([]);
  const [pendenciaProdOn, setPendenciaProdOn] = useState([]);
  const [quarentenaData, setQuarentenaData] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataProd, setFilteredDataProd] = useState([]);
  const [formularios, setFormularios] = useState({});
  const [currentFormContent, setCurrentFormContent] = useState("");
  const [currentFormId, setCurrentFormId] = useState("");
  const [filtroVendedorProd, setFiltroVendedorProd] = useState(0);
  const [filtroProdutor, setFiltroProdutor] = useState(0);
  const [filtroStatusProd, setFiltroStatusProd] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [usersListProd, setUsersListProd] = useState([]);
  const [isModalOpenAguardando, setIsModalOpenAguardando] = useState(false);
  const [isModalOpenFinalizado, setIsModalOpenFinalizado] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [currentUserId, setCurrentUserId] = useState(null);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const textareaRef = useRef(null);
  const [vendedorProdutor, setVendedorProdutor] = useState([]);

  // Cores fixas para alternar entre os grupos
  const groupColors = ["#8BAED3", "#F29098", "#808EA3", "#C0ECAE"];

  useEffect(() => {
    getDemanda();
    fetchData();
  }, []);

  useEffect(() => {
    if (quarentenaData === 0) {
      setFilteredData([]);
    } else if (quarentenaData === 10) {
      setFilteredData(allUsersList.filter((user) => [1, 3, 5].includes(user.status)));
    } else {
      setFilteredData(
        usersList.filter(
          (user) => [1, 3, 5].includes(user.status) && user.vendedor === quarentenaData
        )
      );
    }
  }, [quarentenaData, usersList]);

  async function getDemanda() {
    try {
      const res = await api.get(`/usuariosComFormularios?userPermission=${userPermission}&CPF=${userCpf}`); // Endpoint que retorna usuários e formulários
      const resAll = await api.get(`/allUsuariosComFormularios`); // Endpoint que retorna usuários e formulários
      setAllUsersProdList(resAll.data.users);
      setUsersProdList(res.data.users);
      const { users } = res.data;
      // Verifica se `users` é uma lista válida
      if (!users || !Array.isArray(users)) {
        console.error("Erro: `users` não é um array válido:", users);
        setUsersListProd([]);
        setFilteredDataProd([]);
        return;
      }
      setUsersListProd(users);
      setFilteredDataProd(users);
      // Cria um mapa de formularios baseado nos dados dos usuários
      const formulariosMap = users.reduce((acc, user) => {
        if (user.formularios && Array.isArray(user.formularios)) {
          acc[user.produzirId] = user.formularios;
        } else {
          acc[user.produzirId] = []; // Garante que produzirId tenha um array mesmo se não houver formulários
        }
        return acc;
      }, {});
      setFormularios(formulariosMap);
      const resVendedores = await api.get("/vendedores-produtores");
      const usersvd = resVendedores.data?.data || [];
      setVendedorProdutor(usersvd)
      const produtoresComPendencias = usersvd.filter((vendedor) =>
        users.some(
          (user) => user.produtor === vendedor.cpf && [0, 2, 3, 5].includes(user.status)
        )
      );
      setPendenciaProdOn(produtoresComPendencias);
    } catch (error) {
      console.error("Erro ao buscar usuários e formulários:", error);
    }
  }
  async function fetchData() {
    try {
      const resUsers = await api.get(`/clientes?userPermission=${userPermission}&CPF=${userCpf}`);
      setUsersList(resUsers.data);
      const resAllUsers = await api.get(`/clientesAll`);
      setAllUsersList(resAllUsers.data);
      const resVendedores = await api.get("/vendedores-produtores");
      const users = resVendedores.data?.data || [];
      const vendedoresComPendencias = users.filter((vendedor) =>
        resUsers.data.some(
          (user) => user.vendedor === vendedor.cpf && [1, 3, 5].includes(user.status)
        )
      );
      setPendenciaOn(vendedoresComPendencias);
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
    }
  }

  const updateStatus = async (id, statusDef) => {
    try {
      await api.post("/updateStatus", { id, status: statusDef });
      setUsersList(
        usersList.map((user) =>
          user.id === id ? { ...user, status: statusDef } : user
        )
      );
    } catch (error) {
      console.error("Erro ao atualizar status:", error);
    }
  };

  useEffect(() => {
    // Normaliza texto removendo acentuação e convertendo para minúsculas
    const normalizeText = (text) =>
      text
        ? text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        : "";
    // <-- alteração: se filtroProdutor for 0, não listamos nada
    if (filtroProdutor === 0) {
      setFilteredDataProd([]);
      return; // interrompe aqui
    }
    if (filtroProdutor === 10) {
      setFilteredDataProd(usersListProd);
      return; // interrompe aqui
    }


    // caso contrário, aplica a filtragem normal:
    setFilteredDataProd(
      usersListProd.filter((user) => {
        // Se filtroStatusProd for 0, ignora a filtragem por status
        const statusMatch =
          filtroStatusProd === 0 ||
          user.produzirStatus == filtroStatusProd ||
          (filtroStatusProd === -2 &&
            (user.produzirStatus == 0 || user.produzirStatus == 2));
        // Filtro por Vendedor (se for 0, ignora)
        const vendedorMatch =
          filtroVendedorProd == 0 || user.vendedor == filtroVendedorProd;
        // Filtro por Produtor (já sabemos que != 0 para cair aqui, mas mantemos a lógica)
        const produtorMatch =
          filtroProdutor == 0 || user.produtor == filtroProdutor;
        // Normaliza o termo de busca para comparação
        const normalizedSearchTerm = normalizeText(searchTerm);
        // Filtro de busca por login, nome completo, telefone ou ID DS-160
        const searchMatch =
          !searchTerm.trim() ||
          (user.login &&
            normalizeText(user.login).includes(normalizedSearchTerm)) ||
          user.formularios.some((formulario) => {
            const formularioData = JSON.parse(formulario.formularioData || "{}");
            return (
              normalizeText(
                `${formularioData.nome || ""} ${formularioData.sobrenome || ""}`
              ).includes(normalizedSearchTerm) ||
              (formularioData.telefones || []).some((tel) =>
                normalizeText(tel).includes(normalizedSearchTerm)
              ) ||
              (formulario.ds160_id &&
                normalizeText(formulario.ds160_id.toString()).includes(
                  normalizedSearchTerm
                ))
            );
          });
        // Retorna apenas os usuários que correspondem a TODOS os filtros
        return statusMatch && vendedorMatch && produtorMatch && searchMatch;
      })
    );
  }, [
    usersListProd,
    filtroVendedorProd,
    filtroProdutor,
    filtroStatusProd,
    searchTerm,
  ]);

  const handleClickAguardando = async (user) => {
    if (user.aguardando) {
      setInputValue(user.aguardando)
    }
    setCurrentUserId(user.produzirId);
    setIsModalOpenAguardando(true);
  };
  const handleClickFinalizado = async (user) => {
    console.log("user XXX", user);
    setCurrentUserId(user.produzirId);
    if (user.aguardando) {
      setInputValue(user.aguardando)
    }
    if (user.login) {
      setLogin(user.login)
    }
    if (user.senha) {
      setSenha(user.senha)
    }
    setIsModalOpenFinalizado(true);
  };

  const handleSubmitAguardando = async () => {
    try {
      const response = await api.post('/updateStatusProducao', { id: currentUserId, aguardando: inputValue, status: 2 });
      if (response.status === 200) {
        setIsModalOpenAguardando(false);
        // Atualize a lista de usuários após a atualização
        getDemanda();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error('Erro na solicitação de atualização:', error);
    }
  };

  const handleSubmitFinalizado = async () => {
    try {
      const loginStr = login.toString();
      const senhaStr = senha.toString();
      const response = await api.post('/updateStatusProducao', {
        id: currentUserId,
        aguardando: inputValue,
        status: 1,
        login: loginStr,
        senha: senhaStr
      });
      if (response.status === 200) {
        setIsModalOpenFinalizado(false);
        // Atualize a lista de usuários após a atualização
        getDemanda();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error('Erro na solicitação de atualização:', error);
    }
  };


  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 400)}px`;
    }
  }, [inputValue]);



  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className={styles.app}>
      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>Agendamentos (pendências)</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        <div style={{ width: "100%" }}>
          <div style={{ padding: "10px" }}>
            {/* <h1 style={{ fontSize: "1.4rem", fontWeight: 400 }}>Datas Entregues</h1> */}
          </div>
          <div
            className={styles.filtroDeClientesContainer}
            style={{ marginTop: "10px" }}
          >
            <div className={styles.filterOptionsContainer}>
              <div className={styles.containerVendedor}>
                <div className={styles.inputStyleVendedor}>
                  {pendenciaOn.map((user) => (
                    <div key={user.cpf} className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButton}
                        onClick={() => setQuarentenaData(user.cpf)}
                      >
                        {user.nome}
                      </button>
                      <div className={styles.bolha}>
                        {
                          usersList.filter(
                            (u) =>
                              u.vendedor === user.cpf && [1, 3, 5].includes(u.status)
                          ).length
                        }
                      </div>
                    </div>
                  ))}
                  <div className={styles.setPendenciaDiv}>
                    <button
                      className={styles.setPendenciaButton}
                      onClick={() => setQuarentenaData(10)}
                    >
                      Todos
                    </button>
                    <div className={styles.bolha}>
                      {
                        allUsersList.filter((u) => [1, 3, 5].includes(u.status)).length
                      }
                    </div>
                  </div>

                  {quarentenaData !== 0 && (
                    <div className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButtonClose}
                        onClick={() => setQuarentenaData(0)}
                      >
                        X fechar
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.usersListContainer}>
          {filteredData.map((user) => {
            let dataHorarioEntrevista = "";
            if (user.entrevista) {
              try {
                const entrevista = JSON.parse(user.entrevista);
                if (entrevista.data_horario) {
                  dataHorarioEntrevista = format(
                    parseISO(entrevista.data_horario),
                    "dd-MM-yy"
                  );
                }
              } catch (error) {
                console.error("Erro ao parsear entrevista:", error);
              }
            }
            return (
              <div
                key={user.id}
                style={{
                  width: "100%",
                  backgroundColor: "var(--corPrimaria)",
                  borderRadius: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    color: "white",
                    textAlign: "center",
                    padding: "10px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "0 1 auto" }}>
                    <p>
                      <b>{dataHorarioEntrevista}</b>
                    </p>
                  </div>
                  <div style={{ flex: "1 1 auto" }}>
                    <p className={styles.loginContainer2}>{user.login}</p>
                  </div>
                  <div style={{ flex: "0 1 auto", paddingRight: "20px" }}>
                    {user.vendedor !== 0 && (
                      <p className={styles.icon2}>
                        {
                          vendedorProdutor.find((v) => v.cpf === user.vendedor)?.nome ||
                          "Vendedor não encontrado"
                        }
                      </p>
                    )}
                  </div>
                </div>
                <div
                  style={{ width: "100%", padding: "10px" }}
                  onClick={() => navigator.clipboard.writeText(user.login)}
                >
                  <div style={{ width: "100%" }}>
                    <div className={styles.editIconBoxes}>
                      <div
                        onClick={() => updateStatus(user.id, 2)}
                        className={`${styles.editIconBox} ${styles.green} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaCheck /> <b> &nbsp;Data Final&nbsp; </b>
                        </p>
                      </div>
                      <div
                        onClick={() => updateStatus(user.id, 0)}
                        className={`${styles.editIconBox} ${styles.red} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaTimes /> <b>&nbsp;Retomar Fila&nbsp;</b>
                        </p>
                      </div>
                      <div
                        onClick={() => updateStatus(user.id, 2)}
                        className={`${styles.editIconBox}  ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaWhatsapp style={{ fontSize: "24px" }} />{" "}
                        </p>
                      </div>
                      <div
                        onClick={() => updateStatus(user.id, 2)}
                        className={`${styles.editIconBox} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}>
                          <FaWpforms style={{ fontSize: "24px" }} />{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>DS-160 (pendências)</p>
      </div>
      <div className={styles.cadastroClienteContainer}>
        <div style={{ width: "100%" }}>
          <div
            className={styles.filtroDeClientesContainer}
            style={{ marginTop: "10px" }}
          >
            <div className={styles.filterOptionsContainer}>
              <div className={styles.containerVendedor}>
                <div className={styles.inputStyleVendedor}>
                  {pendenciaProdOn.map((user) => (
                    <div key={user.cpf} className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButton}
                        onClick={() => setFiltroProdutor(user.cpf)}
                      >
                        {user.nome}
                      </button>
                      <div className={styles.bolha}>
                        {
                          usersProdList.filter(
                            (u) =>
                              u.produtor === user.cpf && [0, 2, 3, 5].includes(u.status)
                          ).length
                        }
                      </div>
                    </div>
                  ))}
                  <div className={styles.setPendenciaDiv}>
                    <button
                      className={styles.setPendenciaButton}
                      onClick={() => setFiltroProdutor(10)}
                    >
                      Todos
                    </button>
                    <div className={styles.bolha}>
                      {
                        allUsersProdList.filter((u) =>
                          [0, 2, 3, 5].includes(u.status)
                        ).length
                      }
                    </div>
                  </div>
                  {filtroProdutor !== 0 && (
                    <div className={styles.setPendenciaDiv} >
                      <button
                        className={styles.setPendenciaButtonClose}
                        onClick={() => setFiltroProdutor(0)}

                      >
                        X fechar
                      </button>
                    </div>
                  )}


                </div>
              </div>
            </div>
          </div>
          <div style={{ padding: "10px" }}>

            <ListaFormularios
              users={filteredDataProd.filter(user => user.status !== 1)}
              groupColors={groupColors}
              onClickVer={(user) => window.location.href = `${origin}/formularios/${user.clienteId}`}
              onClickFinalizar={handleClickFinalizado}
              onClickAguardar={handleClickAguardando}
              onClickAnalise={(user) => {/* Se quiser modal de análise, exibe modal aqui */ }}
              setCurrentFormContent={setCurrentFormContent}
              setCurrentFormId={setCurrentFormId}
              // setIsModalOpenForm={setIsModalOpenForm}
              tipo="pendencias" // ou "producao"
            />

          </div>
        </div>
      </div>

      <ModalFinalizar
        open={isModalOpenFinalizado}
        onClose={() => setIsModalOpenFinalizado(false)}
        onSubmit={handleSubmitFinalizado}
        login={login}
        setLogin={setLogin}
        senha={senha}
        setSenha={setSenha}
        inputValue={inputValue}
        setInputValue={setInputValue}
        textareaRef={textareaRef}
      />






      {isModalOpenAguardando && (
        <div className={styles.modalProducao}>
          <div className={styles.modalContentProducao}>
            <h2>Observação do produtor</h2>
            <textarea
              ref={textareaRef}
              style={{ width: "100%", minHeight: "50px", maxHeight: "400px", overflow: "auto", resize: "none" }}
              value={inputValue}
              onChange={handleInputChange}
            />
            <button onClick={handleSubmitAguardando}>Registrar</button>
            <button onClick={() => { setIsModalOpenAguardando(false); setInputValue("") }}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pendencias;
